<template>
    <!-- 权限管理-员工管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'user')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="员工姓名">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="员工手机">
                        <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="登录账号">
                        <a-input placeholder="请输入" v-decorator="['account']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="员工角色">
                        <a-select allowClear v-decorator="['roleId']" placeholder="请选择" @select="search">
                            <a-select-option v-for="item in options" :key="item.id" :value="item.id">{{item.roleName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="员工状态">
                        <a-select allowClear v-decorator="['isEnable']" @select="search">
                            <a-select-option :value="0">已冻结</a-select-option>
                            <a-select-option :value="1">使用中</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button class="mr8" type="primary" @click="search">筛选</a-button>
                        <a-button @click="reset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <a-button slot="extra" v-if="getBtnByAuth('addUser')" type="primary" @click="$router.push({name: 'addUser'})">新增员工账户</a-button>
                <a-table
                    :scroll="{y: 610}"
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    :rowKey="record => record.id"
                >
                    <template slot="index" slot-scope="a,b,index">{{index+1}}</template>
                    <span slot="roleName" slot-scope="roleName">{{roleName[0].roleName}}</span>
                    <template slot="empty" slot-scope="empty">{{empty || '--'}}</template>
                    <span slot="isEnable" slot-scope="key">{{key ? '使用中' : '已冻结'}}</span>
                    <span slot="action" slot-scope="text, record">
                        <span v-if="getBtnByAuth('updateUser')">
                            <router-link class="text-primary" :to="{name:'editUser', query:{id: record.id}}">编辑</router-link>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('resetPwd')">
                            <a class="text-primary" @click="openModal(record)">密码重置</a>
                            <a-divider type="vertical"/>
                        </span>
                        <a-popconfirm v-if="getBtnByAuth('userState')" :title="'确认将该员工'+ (record.isEnable ? '冻结？' : '解冻？')" @confirm="changeState(record)">
                            <a class="text-primary">{{record.isEnable ? '冻结' : '解冻'}}</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
            <!-- 重置密码弹窗 -->
            <a-modal
                title="重置密码"
                :visible="visible"
                :confirmLoading="confirmLoading"
                centered
                @ok="resetPwd"
                @cancel="visible=false"
                >
                <p>确认将员工“{{item.name}}”的密码重置为“3e7w8dps”吗？</p>
            </a-modal>

        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index"}
    },
    {
        title: "员工姓名",
        dataIndex: "name"
    },
    {
        title: "员工手机",
        dataIndex: "phone"
    },
    {
        title: "登录账号",
        dataIndex: "account"
    },
    {
        title: "员工角色",
        dataIndex: "roleList",
        scopedSlots: { customRender: "roleName" }
    },
    {
        title: "门店权限",
        dataIndex: "shopName",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "员工状态",
        dataIndex: "isEnable",
        scopedSlots: { customRender: "isEnable" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }
];

export default {
    name: "",
    components: {},
    props: {},
    data() {
        return {
            options: [],
            columns,
            dataSource: [],
            pagination: {
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                pageSize: 20,
                current: 1,
                showTotal() {
                    return `共 ${this.total} 条数据`
                },
                // 尺寸变化
                onShowSizeChange: (current, size) => {
                    this.sizeChange(current, size)
                },
                // 页码变化
                onChange: (page, pageSize) => {
                    this.currentChange(page, pageSize)
                }
            },
            loading: true,
            confirmLoading: false,
            visible: false,
            item: {}
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    methods: {
        // 分页器操作
        sizeChange(current, size) {
            this.pagination.current = 1;
            this.pagination.pageSize = size;
            this.getList();
        },
        currentChange(page, pageSize) {
            this.pagination.current = page;
            this.getList();
        },

        // 重置搜索条件
        reset(){
            this.form.resetFields()
            this.getList()
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },

        // 获取数据列表
        getList() {
            if(!this.shopId) return;
            let { current, pageSize } = this.pagination;
            let searchParams = this.form.getFieldsValue();
            if (typeof searchParams.isEnable !== 'undefined') {
                searchParams.isEnable = Boolean(searchParams.isEnable);
            }
            this.$api.jurisdiction.userList({
                body: {
                    pageNum: current,
                    pageSize,
                    shopId: this.$store.state.platform.shopId,
                    ...searchParams
                }
            }).then(res => {
                this.loading = false;
                res.list && res.list.forEach(e => {
                    e.shopName = [];
                    e.shopList && e.shopList.forEach(shop => {
                        e.shopName.push(shop.name);
                    })
                    e.shopName = e.shopName.join('，');
                })
                this.dataSource = res.list;
                this.pagination.total = res.total;
            }).catch(err => {
                this.loading = false;
            })
        },

        // 冻结、解冻
        changeState(record){
            let {isEnable,id} = record;
            this.$api.jurisdiction[isEnable ? 'userFreeze' : 'userUnfreeze']({
                params: {
                    id
                }
            }).then(data=>{
                this.$message.success(isEnable ? '冻结成功' : '解冻成功');
                this.getList();
            })
        },
        /**
         * 打开重置密码弹窗
         */
        openModal(record){
            this.visible = true;
            this.item = record;
        },
        /**
         * 重置密码
         */
        resetPwd(){
            this.confirmLoading = true;
            this.$api.jurisdiction.resetPwd({
                params: {
                    id: this.item.id
                }
            }).then(data=>{
                this.visible = false;
                this.confirmLoading = false;
                this.$message.success('操作成功！');
                this.getList();
            })
        },

        // 获取角色列表
        getRoleList() {
            this.$api.jurisdiction.selectList({}).then(data => {
                this.options = data;
            });
        },
    },
    created() {},
    mounted() {
        this.getList()
        this.getRoleList()
    },
    watch: {
        '$route'(val) {
            val.name == 'user' && this.getList();
        },
        'shopId'() {
            this.reset()
            this.getRoleList()
        }
    }
};
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
</style>
